<template>
  <div class="candidate-page">
    <router-view></router-view>
    <Footer />
  </div>
</template>

<script>
import Footer from "@/components/Layout/Footer";

export default {
  name: "candidateLayout",
  components: {
    Footer,
  },
};
</script>
